import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { holdConsole } from "./boot/console";
import { holdTelemetry } from "./boot/telemetry";
import { startFrontendRuntime } from "./boot/runtime";
import { updater } from "@features/updater";
import { holdJournal } from "@shared/lib/journal";
import { holdContextMenu } from "@shared/lib/context-menu";
import { holdAccessibility } from "@shared/ui/accessibility";
import "./styles/tokens.css";
import "./styles/emoji-font.css";
import "./styles/shadcn.css";
import "./styles/base.css";
import "./styles/ui.css";

/*
 * Тема и тон обоев ставятся до первой отрисовки, иначе тёмный интерфейс
 * моргнёт светлым.
 *
 * Обои прежде ставил эффект в оболочке — то есть уже после первого кадра, и
 * первый кадр показывал ровный тон вместо выбранного. Теперь оба положения
 * приезжают отсюда, а меняет их тот, кто их меняет.
 */
document.documentElement.dataset.theme = localStorage.getItem("airel.theme") ?? "dark";
document.documentElement.dataset.wall = localStorage.getItem("airel.wall") ?? "aurora";
holdAccessibility();

/*
 * До отрисовки и без снятия: правая кнопка занята нашим меню на всё время
 * работы приложения. Снимать нечего — вместе со страницей уходит и слушатель.
 */
void startFrontendRuntime({
  // Локальный журнал нужен и health probe: он не открывает сеть или media.
  holdLocalDiagnostics: holdJournal,
  detectBootMode: updater.detectBootMode.bind(updater),
  startNormalRuntime: () => {
    holdContextMenu();
    holdTelemetry();
    // Ручки настройки звука на слух. Временные — см. `app/boot/console.ts`.
    holdConsole();
  },
  render: () => {
    createRoot(document.getElementById("root")!).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  },
});
